import { graphql, useStaticQuery } from "gatsby";

const useProSiteNavigationData = () => {
  return useStaticQuery(graphql`
    query SupertriNavigationSetQuery {
      navigationSets: allContentfulNavigationSet(
        filter: {
          navigationSetName: {regex: "/^supertri\\s\\>\\s.*$/"},
          node_locale: {eq: "en-GB"},
          id: {ne: "bd773ebc-b794-5b9f-8f06-13d5f6ac16fa"}
        }
      ) {
        nodes {
          navigationSetName
          navigationSetItems {
            __typename
            ... on ContentfulNavigationDropdown {
              navigationDropdownItems {
                ... on ContentfulNavigationEntry {
                  __typename
                  pageLink {
                    __typename
                    ... on ContentfulProPage {
                      slug
                      brand {
                        id
                      }
                    }
                    ... on ContentfulResultsPage {
                      slug
                      brand {
                        id
                      }
                    }
                    ... on ContentfulProEvent {
                      slug
                      brand {
                        id
                      }
                    }
                  }
                  linkText
                  externalUrl
                  openLinkInNewWindow
                }
              }
              title
              dropdownText
              dropdownType
            }
            ... on ContentfulNavigationEntry {
              linkText
              pageLink {
                __typename
                ... on ContentfulProPage {
                  slug
                  brand {
                    id
                  }
                }
                ... on ContentfulResultsPage {
                  slug
                  brand {
                    id
                  }
                }
                ... on ContentfulProEvent {
                  slug
                  brand {
                    id
                  }
                }
              }
              externalUrl
              openLinkInNewWindow
            }
          }
        }
      }
      
      allEvents: allContentfulProEvent(
        filter: {
          node_locale: {eq: "en-GB"},
          id: {ne: "83084356-0475-5bf6-826b-31eeed3d0b55"}
        }
        sort: {startDate: ASC}
      ) {
        nodes {
          title
          brand {
            name
          }
          startDate
          slug
          endDate
          thumbnail {
            gatsbyImageData(width: 350)
            description
          }
        }
      }

      allTeamPages: allContentfulTeamPage(
        filter: {
          node_locale: {eq: "en-GB"},
          slug: {ne: "blank-team-page"}
        }
        sort: {slug: ASC}
      ) {
        nodes {
          slug
          thumbnail {
            gatsbyImageData(width: 700)
          }
          team {
				     name
				     colour
				     dropdownOrder
           }
         }
      }

      allTeams: allContentfulTeamPage(
         filter: {
           node_locale: {eq: "en-GB"},
           slug: {ne: "blank-team-page"}
         }
         sort: {slug: ASC}
       ) {
         nodes {
           slug
           thumbnail {
             gatsbyImageData(width: 1750)
           }
           team {
             name
             colour
           }
         }
      }
      
      supertrieEvent: allContentfulProEvent(
        filter: {
          brand: {
            name: {eq: "supertri E"}
          },
          node_locale: {eq: "en-GB"},
          id: {ne: "83084356-0475-5bf6-826b-31eeed3d0b55"}
        }
        sort: { startDate: ASC }
        limit: 1
      ) {
        nodes {
          title
          brand {
            name
          }
          slug
          startDate
          endDate
          thumbnail {
            gatsbyImageData(width: 350)
            description
          }
        }
      }

      supertriEvents: allContentfulProEvent(
         filter: {
           brand: {
             name: {eq: "supertri"}
           },
           node_locale: {eq: "en-GB"},
           id: {ne: "83084356-0475-5bf6-826b-31eeed3d0b55"},
           slug: { nin: ["toulouse-2024-fr", "toulouse-triathlon"] }
         }
         sort: { startDate: ASC }
         limit: 10
       ) {
         nodes {
           title
           brand {
             name
           }
           slug
           startDate
           endDate
           thumbnail {
             gatsbyImageData(width: 350)
             description
          }
        }
      }

      supertrieEvents: allContentfulProEvent(
         filter: {
           brand: {
             name: {eq: "supertri E"}
           },
           node_locale: {eq: "en-GB"},
              id: {ne: "83084356-0475-5bf6-826b-31eeed3d0b55"}
         }
         limit: 10
       ) {
         nodes {
           title
           brand {
             name
           }
           slug
           startDate
           endDate
           thumbnail {
             gatsbyImageData(width: 350)
             description
          }
        }
      }
  
      supertriLatest: allContentfulPost(
        filter: {
          type: {ne: "Video"},
          node_locale: {eq: "en-GB"},
          id: {ne: "e19ef1c0-349d-5302-85e0-7da7b22f1fef"},
          brand: {
            name: {eq: "supertri"}
          }
        }
        limit: 5
      ) {
        nodes {
          title
          brand {
            name
          }
          slug
          thumbnail {
            gatsbyImageData(width: 350)
            description
          }
          excerpt {
            excerpt
          }
          metadata {
              tags {
              name
            }
          }
        }
      }
      
      supertrieLatest: allContentfulPost(
        filter: {
          type: {ne: "Video"},
          node_locale: {eq: "en-GB"},
          id: {ne: "e19ef1c0-349d-5302-85e0-7da7b22f1fef"},
          brand: {
            name: {eq: "supertri E"}
          }
        }
        limit: 5
      ) {
        nodes {
          title
          brand {
            name
          }
          slug
          thumbnail {
            gatsbyImageData(width: 350)
            description
          }
          excerpt {
            excerpt
          }
          metadata {
            tags {
           name
         }
        }
        }
      }

		supertriVideos: allContentfulPost(
        filter: {
          type: {eq: "Video"},
          node_locale: {eq: "en-GB"},
          brand: {
            name: {eq: "supertri"}
          }
        }
        limit: 5
      ) {
        nodes {
          title
          brand {
            name
          }
          slug
          thumbnail {
            gatsbyImageData(width: 350)
            description
          }
          excerpt {
            excerpt
          }
          videoSrcUrl {
            videoSrcUrl
          }
          metadata {
            tags {
              name
            }
          }
        }
      }

		supertrieVideos: allContentfulPost(
        filter: {
          type: {eq: "Video"},
          node_locale: {eq: "en-GB"},
          brand: {
            name: {eq: "supertri E"}
          }
        }
        limit: 5
      ) {
        nodes {
          title
          brand {
            name
          }
          slug
          thumbnail {
            gatsbyImageData(width: 350)
            description
          }
          excerpt {
            excerpt
          }
          videoSrcUrl {
            videoSrcUrl
          }
          metadata {
            tags {
              name
            }
          }
        }
      }
      
      supertrieWatch: allContentfulPost(
        filter: {
          type: {eq: "Video"},
          node_locale: {eq: "en-GB"},
          id: {ne: "e19ef1c0-349d-5302-85e0-7da7b22f1fef"},
          brand: {
            name: {eq: "supertri E"}
          }
        }
        limit: 3
      ) {
        nodes {
          title
          brand {
            name
          }
          slug
          thumbnail {
            gatsbyImageData(width: 350)
            description
          }
          excerpt {
            excerpt
          }
          videoSrcUrl {
            videoSrcUrl
          }
          metadata {
            tags {
              name
            }
          }
        }
      }
  }`);
};

export default useProSiteNavigationData;
